<!-- 数据统计 -->
<template>
    <Layout>
        <div class="row">
            <div class="outBox">
                <div class="blue-bg">
                    <div class="main-box">
                        <div class="main-item flex-depart-center" v-for="(item,index) in dataList" :key="index">
                            <div class="m-left flex-depart-left-center">
                                <template v-if="Number(item.rank) > 3">
                                    <span>{{ item.rank }}</span>
                                </template>
                                <template v-if="Number(item.rank) <= 3">
                                    <img class="ph" :src="rankImages[item.rank]">
                                </template>
                                <img class="tx" :src="item.profile_photo">
                                <div class="xm">{{ item.name }}</div>
                            </div>
                            <div class="m-right">{{ item.checkin_count }}次</div>
                        </div>
                    </div>
                </div>
                <div style="text-align: center;padding-bottom: 50px;padding-top: 40px">
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            @current-change="handleCurrentChange">
                    </el-pagination>
                </div>

            </div>
        </div>
    </Layout>
</template>
<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import { imageUrl } from "@/utils/config/commonUrl.js";
    import {
        activityRanking,
    } from "@/utils/api/activity";
    import { activityDetail} from "@/utils/api/build";

    export default {
        page: {
            title: "打卡排行榜",
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: { Layout },
        data() {
            return {
                activityId: '',
                mescroll: null, // mescroll实例对象 (此行可删,mixins已默认)
                // 下拉刷新的配置(可选, 绝大部分情况无需配置)
                downOption: {

                },
                // 上拉加载的配置(可选, 绝大部分情况无需配置)
                upOption: {
                    page: {
                        size: 10 // 每页数据的数量,默认10
                    },
                    noMoreSize: 5, // 配置列表的总数量要大于等于5条才显示'-- END --'的提示
                    empty: {
                        tip: '暂无相关数据'
                    }
                },
                // 列表数据
                dataList: [],
                pageNum: 1,
                actName: '',
                loadingFlag: false,
                loadingFinished: false,
                nodataFinished: false,
                hasMore: false,
                imageUrl2: this.imageUrl,
                jiangBei: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/ranking-jiangbei1.svg',
                img1: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/ranking-one.svg',
                img2: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/ranking-two.svg',
                img3: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/ranking-three.svg',

                rankImages: {
                    1: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/rank-first.svg',
                    2: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/rank-sec.svg',
                    3: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/rank-three.svg',
                },
                routeParameter: {},
                pageSize: 15,
                total: 0,
                activityKey: '',

            };
        },
        created() {

        },
        mounted(){
            // 页面参数
            this.routeParameter = this.$route.query;
            if (this.routeParameter.activityId){
                this.activityId = this.routeParameter.activityId;
            }
            if (this.routeParameter.alias){
                this.activityKey = this.routeParameter.alias;
            }
            if (this.routeParameter.actName){
                this.actName = this.routeParameter.actName;
            }
            this._activityRanking()
        },
        methods:{

            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.pageNum = val;
                this._activityRanking()
            },
            async _activityRanking(){
                let result = await activityRanking({
                    activityId: this.activityId,  //活动id
                    pageNum: this.pageNum,    //分页 第一页 默认是1 下拉需要传
                    pageSize: 15   //分页显示条数  默认10  不需要传
                })
                if (result.status == 1){
                    // 接口返回的当前页数据列表 (数组)
                    let curPageData = result.data.list;
                    this.hasMore = result.data.hasNextPage;
                    this.total = result.data.total;
                    this.dataList = curPageData; //追加新数据

                    if (result.data.pages == result.data.pageNum){
                        this.loadingFlag = false;
                        this.loadingFinished = true;
                    }
                    if (this.dataList.length == 0){
                        this.nodataFinished = true;
                        this.loadingFlag = false;
                        this.loadingFinished = false;
                    } else {
                        this.loadingFlag = false;
                        this.nodataFinished = false;
                        this.loadingFinished = true;
                    }

                }
            },
        }
    };
</script>
<style lang="scss" scoped>
    .outBox{
        background-color: white;
        width: 100%;
    }
    .rk-top{
        height: 116px;
        background: linear-gradient(129deg,#3768ec, #3768ec, #6181fa 92%);
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 18px;
        color: white;
        word-break: break-word;
        font-weight: bold;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
    }
    .loading-style{
        font-size: 12px;
        color: grey;
        text-align: center;
        line-height: 45px;
    }
    .noneRecord {
        width: 375px;
        height: 250px;
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 75px;

        image {
            width: 150px;
            height: 120.5px;
        }

        span {
            margin-top: 15px;
            font-size: 12px;
            color: gray;
        }
    }
    .jiangbei{
        width: 91px;
        height: 102px;
        position: absolute;
        right: 0;
        top: 15px;
    }
    .main-box{
        background-color: white;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 0 15px;
        box-sizing: border-box;
        z-index: 999;
        position: relative;
        top: -15px;
    }
    .main-item{
        padding: 20px 10px;
        border-bottom: 1px solid #DEDEDE;
    }
    .m-left text{
        display: inline-block;
        min-width: 20px;
        margin-right: 10px;
    }
    .tx{
        width: 35px;
        height: 35px;
        margin-right: 10px;
        border-radius: 100%;
    }
    .xm{
        max-width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        font-size: 14px;
        font-weight: bold;
        color: #636a84;
    }
    .m-right{
        font-size: 13px;
        color: #9b9fac;
    }
    .ph{
        width: 31px;
        height: 26px;
        margin-right: 5px;
    }
    /* flex布局 */
    .flex-depart-left {
        display: flex;
        align-items: center;
    }

    .flex-depart-center {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .flex-depart-center-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex-depart-center-end {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .flex-depart-top {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .flex-depart-right-top {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
    }

    .flex-depart-left-warp {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .flex-depart-left-center{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
</style>
